import {Component, DestroyRef, inject, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../../../store';
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {combineLatest, Observable, Subject, Subscription} from "rxjs";
import {Website} from "../../../website";
import {ActivatedRoute, Router} from "@angular/router";
import {HostingService} from "../../hosting.service";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {DbModalService} from "../../../../../modules/modal/modal";
import {Utils} from "../../../../../shared/utils/utils";
import {Config} from "../../../../../config/config";
import {debounceTime, distinctUntilChanged, filter, first, switchMap, takeUntil} from "rxjs/operators";
import {IDomainExpandedDataEntityState} from "../../../../../store/reducers/domain-expanded-data.reducer";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {AddDomainSuccessDialogComponent} from "../add-domain-succes-dialog/add-domain-success-dialog.component";
import {AddDomainListDialogComponent} from "../add-domain-from-list/add-domain-list-dialog.component";
import {AddCustomDomainDialogComponent} from "../add-domain-dialog/add-custom-domain-dialog.component";
import {
  MobileAvailableComponent
} from "../../../../../shared/components/dialogs/mobile-available/mobile-available.component";
import {UserSubscription, UserSubscriptionIds, UserSubscriptionType} from "../../../../../user/user-subscription";
import {User} from "../../../../../user/user";
import {Payment} from "../../../../../user/payment";
import {HostingData} from "../../info/hostingData";
import {HostingDomainData} from "../hostingDomainData";
import addDomainsDropdownList from "../domains-action-list.json";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {clientRoles} from "../../../../../user/user-roles-actions";
import {Workspace} from "../../../../../user-managment/workspace";
import {merge} from "rxjs/internal/observable/merge";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../../../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {IDsDropdownOption} from "../../../../../shared/components/ds-dropdown/ds-dropdown-option";
import {
  PricingPageViewComponent
} from "../../../../../shared/components/dialogs/one-month-free/components/pricing-page-view/pricing-page-view.component";
import {OneMonthFreeComponent} from "../../../../../shared/components/dialogs/one-month-free/one-month-free.component";
import {BuilderSectionsInteractionService} from "../../../../../builder-v2/builder-sections-interaction.service";
import {MainDomainI} from "../../../../../components/pages/10web-API/components/custom-domain/custom-domain.interface";

interface ITab {
  id: 'Domain name' | 'Status' | 'Actions';
  label: string;
}

@Component({
    selector: 'db-hosting-domains-list',
    templateUrl: './hosting-domains-list.component.html',
    styleUrls: ['./hosting-domains-list.component.scss'],
    standalone: false
})
export class HostingDomainsListComponent implements OnInit, OnDestroy {

  protected readonly clientRoles = clientRoles;
  protected readonly UserSubscriptionType = UserSubscriptionType;

  hasDomainBuyAccess: boolean = true;
  domainsLoading$: Observable<boolean>;
  domains: HostingDomainData[];
  zones: any;
  website: Website;
  websites: Website[];
  websitesUrls: any = {};
  primaryDomain: HostingDomainData;
  subscriptions: Subscription[];
  hasHostingBanner: any;
  user: User;
  userSubscription: UserSubscription;
  primaryChanged: boolean;
  firstInfoLink: string = "https://help.10web.io/hc/en-us/articles/360027855951-How-do-I-point-my-domain-to-10Web-VIDEO-";
  isMobile: boolean = false;
  demoUser: boolean = false;
  payments: Payment[];
  domainOptions: Array<IDsDropdownOption>;
  checkStatusesLoading: boolean = true;
  purchasedNotLinked: any;
  hostingInfoData: HostingData;
  zone: any;
  zoneLimit: number;
  hostingZonesData: any;
  showManageDNS: boolean;
  userLocalStorage;
  listLoading = false;
  suggestedDomain: string;
  currentWorkspace: Workspace;
  loadPage = true;
  mainDomain: MainDomainI | null;

  tabs = [
    {
      id: 'name',
      title: 'Domain name'
    },
    {
      id: 'status',
      title: 'Status'
    },
    {
      id: 'action',
      title: 'Action'
    }
  ];
  companyName: string = 'Dashboard';
  private _destroyRef = inject(DestroyRef);
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  private _openSearch = this._route.snapshot.queryParams['domain_id'];
  private _fromWidgetSearch = this._route.snapshot.queryParams['from_widget'];
  private _searchTerm = this._route.snapshot.queryParams['domain'];

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _route: ActivatedRoute,
    private _hostingService: HostingService,
    private _router: Router,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _modalService: DbModalService,
    private _builderSectionsInteractionService: BuilderSectionsInteractionService,
  ) {
  }

  ngOnInit(): void {
    this._getCompanyInfo();
    this.domainOptions = [...addDomainsDropdownList];
    this.payments = this._route.snapshot.data['payments'];
    this.website = this._route.snapshot.parent.parent.data['website'];
    this.suggestedDomain = this.website?.title || '';

    this.primaryChanged = !Utils.checkStringInArray(this.website.site_url, Config.hostnameList);
    this.domainsLoading$ = this._store.select(fromStore.getDomainsLoading(this.website.id));
    this.userSubscription = this._route.snapshot.parent.parent.data['userSubscription'];
    this.isMobile = window.innerWidth <= 991;
    this._getCurrentWorkspace();
    this._setHostingInfoData();
    this._getMainDomain();
    this.addEventHandlers();
    this._openSearchFromBuilder();
  }

    private _getCompanyInfo(): void {
        this._builderSectionsInteractionService.companyInfo
            .pipe(
                filter(companyInfo => !!companyInfo),
                takeUntil(this._destroyStream$),
                first()
            )
            .subscribe(companyInfo => {
                this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
            });
    }

  private _getCurrentWorkspace() {
    this._store.select(fromStore.getCurrentWorkspace)
      .pipe(
        first()
      )
      .subscribe(currentWorkspace => {
        this.currentWorkspace = currentWorkspace;
        this.hasDomainBuyAccess = [clientRoles.COMPANY_ADMIN, clientRoles.OWNER].includes(this.currentWorkspace?.roleId);
      });
  }

  private _getMainDomain() {
    this._store.select(fromStore.getMainDomain)
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(mainDomain => {
        this.mainDomain = mainDomain;
      });
  }

  private _openSearchFromBuilder(open = false) {
    if (this._openSearch || open) {
      this._addDomainFromSearch();
    }
  }

  private addEventHandlers(): void {
    this.subscriptions = [];

    this.subscriptions.push(
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getUserSubscription),
            this._store.select(fromStore.getUserLocalStorage)
          )),
          filter(([user, userSubscription]) => !!user && !!userSubscription)
        )
        .subscribe(([user, userSubscription, userLocalStorage]) => {
          this.user = user;
          this.userSubscription = userSubscription;
          this.hasHostingBanner = localStorage.getItem("showConnectBanner" + this.user.id);
          this.demoUser = Utils.isDemoUser(userSubscription, user);
          this.zoneLimit = this.user.additionalWebsiteCount ? parseInt(this.user.hosting_services.zone_limit.parameter_value, 10) + (parseInt(this.user.additionalWebsiteCount, 10) * parseInt(this.user.hosting_services.additional_zone_limit.parameter_value, 10)) : parseInt(this.user.hosting_services.zone_limit.parameter_value, 10);
          this.userLocalStorage = userLocalStorage;
        })
    );


    this.subscriptions.push(this._store.select(fromStore.getAllWebsites).subscribe((websites: any) => {
      if (websites) {
        websites.map((website: Website) => {
          if (!website.domain_hash) {
            Object.assign(this.websitesUrls,
              {[website.id]: website.site_url.replace(/^(?:https?:\/\/)?(?:www\.)?/, '')});
          }
        });
      }
    }));
    this.subscriptions.push(
      this._store.select(fromStore.getZonesList(this.website?.multisiteType === 'subfolder' ? this.website.children[0] : this.website?.id))
        .pipe(
          filter(zones => !!zones && zones.length),
          distinctUntilChanged(([prevZone], [currZones]) => prevZone?.length === currZones?.length),
          takeUntil(this._destroyStream$)
        )
        .subscribe(zones => {
            this.hostingZonesData = zones;
          }
        )
    );

    this.subscriptions.push(
      this._store.select(fromStore.getWebsitesLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getDomains(this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id)),
            this._store.select(fromStore.getWebsite(this.website?.id))
          )),
          takeUntil(this._destroyStream$),
          debounceTime(500)
        ).subscribe(([domains, website]) => {
        this.loadPage = false;
        this.website = website;
        this.domains = domains.length ? domains : [];

        if (this.domains.length) {
          this.domains.forEach(domain => {
            this._checkDomainsStatuses(domain);
          });
          this.domains.map(domain => {
            Object.keys(this.websitesUrls).map((key, index) => {
              if (this.websitesUrls[key] === domain.name) {
                domain.isConnected = true;
                domain.connectedWebsiteId = key;
              }
            });
          });

          this.primaryDomain = this.domains.find((domain: HostingDomainData): boolean => !!domain.default);
          this.primaryChanged = !Utils.checkStringInArray(this.primaryDomain.siteUrl, Config.hostnameList);
          this._filterDomainsList(this.domains);
          this.listLoading = false;
          if (this._fromWidgetSearch && this.domains?.length > 1) {
            this._fromWidgetSearch = false;
            this._openSearchFromBuilder(true);
          }
        }
      })
    );

  }

  private _filterDomainsList(domains): void {
    let domainsList: any[];
    domainsList = domains.sort((domain1: HostingDomainData, domain2: HostingDomainData) => {
      const isSubdomain1 = this._isSubdomain(domain1);
      const isSubdomain2 = this._isSubdomain(domain2);

      if (domain1 && domain2) {
        if (domain1.default && !domain2.default) {
          return -1;
        } else if (!domain1.default && domain2.default) {
          return 1;
        } else {
          // Both have the same default status or both are non-default
          if (isSubdomain1 && !isSubdomain2) {
            return 1;
          } else if (!isSubdomain1 && isSubdomain2) {
            return -1;
          }
        }
      }
      return 0;
    });
    this.domains = domainsList;
  }

  private _isSubdomain(domain: HostingDomainData): boolean {
    let isSubdomain = false;
    Config.hostnameList.forEach((hostname) => {
      if (domain.name.indexOf(hostname) !== -1) {
        isSubdomain = true;
      }
    });
    return isSubdomain;
  }

  public manageDns(zoneId: string) {
    if (window.innerWidth < 991 && this.user && this.user.subscriptionId === UserSubscriptionIds.TRIAL) {
      this._dialogService.addDialog(MobileAvailableComponent, {
        header: 'Available Only On Desktop',
        message: "We're sorry, this page can only be accessed<br/>from Desktop version."
      });
    } else {
      this._router.navigate(['./domains-manage-dns/' + zoneId], {relativeTo: this._route});
      this.showManageDNS = true;
    }

  }

  public addDomain(option): void {
    if (this.user && this.user.subscriptionId === Config.defaultStarterPlanId) {
      return this.showCheckoutDialog('Dashboard: Connect your domain: Dashboard - Domains');
    }
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: "Connect your domain",
      eventLabel: 'Connect your domain: Domains'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    switch (option) {
      case 'list':
        this._addDomainFromList();
        break;
      case 'search':
        this._addDomainFromSearch();
        break;
      case 'other':
        this.addDomainFromOtherProvider();
        break;
    }
  }

  public addDomainFromOtherProvider(): void {
    if (this.user && this.user.subscriptionId === Config.defaultStarterPlanId) {
      return this.showCheckoutDialog('Dashboard: Connect your domain: Dashboard - Domains');
    } else {
      const analyticsData = {
        eventCategory: 'Dashboard Action',
        eventAction: "Click From other provider",
        eventLabel: 'Dashboard: Domains (Website Management)'
      };
      this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
      const modal = this._modalService.open(AddCustomDomainDialogComponent, {overflowHidden: false, width: 700});
      modal.componentInstance.website = this.website;
      modal.componentInstance.ipv4Address = this.hostingInfoData.hostingBasicInfo.ip;
      const combinedObservable = merge(modal.closed, modal.dismissed);
      combinedObservable.subscribe((value) => {
        if (value && value.success) {
          this.loadDomains();
          NotifierComponent.notify(new Notification('Domain was successfully added', NotificationType.SUCCESS));
        }
      });
    }

  }

  private _addDomainFromList(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: "Click From the domain list",
      eventLabel: 'Domains (Website Management)'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    const modal = this._modalService.open(AddDomainListDialogComponent, {overflowHidden: false, width: 500});
    modal.componentInstance.website = this.website;
    modal.closed.subscribe((value) => {
      if (value && value.success) {
        this._store.dispatch(new fromStore.LoadDomains({
          websiteId: this.website?.id,
          childWebsiteId: this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : null
        }));
        this._store.dispatch(new fromStore.LoadZones());
        this._dispatchPurchasedDomains();
        this._openSuccessDialog();
        NotifierComponent.notify(new Notification('Domain was successfully added', NotificationType.SUCCESS));
      }
    });
  }

  public _openSuccessDialog(): void {
    this._modalService.open(AddDomainSuccessDialogComponent, {width: 700});
  }


  private _addDomainFromSearch(fromBanner = false): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: "Click Search for a new domain",
      eventLabel: 'Domains (Website Management)'
    };
    !fromBanner && this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }


  public loadDomains() {
    this._dispatchPurchasedDomains();
    this._store.dispatch(new fromStore.LoadDomains({
      websiteId: this.website.id,
      childWebsiteId: this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : null
    }));
    this._store.dispatch(new fromStore.LoadZones());
  }

  public updateWebsiteData() {
    if (this.website) {
      this._dispatchPurchasedDomains();
      this._store.dispatch(new fromStore.UpdateWebsiteData(this.website.id));
      this._store.dispatch(new fromStore.LoadInfo(this.website.id));
    }
  }

  private removeEventHandlers(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((subscription: Subscription): void => {
        subscription.unsubscribe();
      });
    }
    this.subscriptions = null;
  }

  private showCheckoutDialog(label): void {
    const analyticsData = {
      eventCategory: this.demoUser ? 'Free Upgrade Offer' : 'Free trial paywalls',
      eventAction: "Locked button click",
      eventLabel: label
    };

    if (this.userSubscription?.trialClient) {
      if (this.demoUser) {
        this.showDemoUpgradeDialog();
      } else {
        const modal = this._modalService.open(PricingPageViewComponent, {
          overflowHidden: true,
          height: 960,
          width: 1076
        });
        modal.componentInstance.user = this.user;
        modal.componentInstance.fromDomain = true;
      }
    } else {
      const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
      modal.componentInstance.mode = 'general';
      modal.componentInstance.customDomainFlow = true;
    }

    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private _checkDomainsStatuses(domain): void {
    this._store.select(fromStore.getDomainExpandedData(domain.id))
      .pipe(
        takeUntil(this._destroyStream$),
        filter(data => !TypeUtils.isEmpty(data)),
      )
      .subscribe((data: IDomainExpandedDataEntityState) => {
        this.checkStatusesLoading = false;
        domain.domainPointed = data.domainPointed;
        domain.tenWebDomain = data.tenWebDomain;
        domain.tenWebNs = data.tenWebNs;
        domain.verificationNeeded = data.verificationNeeded;
      });
  }

  /*this._hostingService.checkPointedDomain(
    this.website.multisiteType === 'subfolder' ? this.website.children[0] : this.website.id,
    nameIds,
    true
  ).pipe(
    first(response => !!response, null)
  )
    .subscribe(response => {
      if (response.success) {
        this.domains.map((domain: any) => {
          const domainId = domain.id;
          if (response.data.troubleshoot_result[domainId]) {
            domain.pointed = response.data.troubleshoot_result[domainId].domain_pointed;
            this.checkStatusesLoading = false;
          }
        })
      }
    });*/
  private _setHostingInfoData(): void {
    this._store.select(fromStore.getInfoLoaded(this.website?.id))
      .pipe(
        filter((loaded: boolean) => !!loaded),
        switchMap(() => this._store.select(fromStore.getInfo(this.website?.id))),
        first()
      )
      .subscribe((hostingInfo: any): void => {
        if (hostingInfo) {
          this.hostingInfoData = hostingInfo;
        }
      });
  }

  reloadDomains() {
    if (this.listLoading) {
      return;
    }
    this.listLoading = true;
    this.loadDomains();
  }

  private _dispatchPurchasedDomains() {
    this.userSubscription?.plan?.hasDomainService && this._store.dispatch(new fromStore.LoadPurchasedDomains(this.website?.id));
  }


  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
    this.removeEventHandlers();
  }

  showDemoUpgradeDialog() {
    const firstTime = TypeUtils.isNull(localStorage.getItem('dbShowFirstTime'));
    const options = {
      overflowHidden: false,
    };
    if (!firstTime) {
      options['width'] = 1240;
    } else {
      options['width'] = 460;
      options['height'] = 600;
    }
    const modal = this._modalService.open(OneWeekFreeDemoUpgradeComponent, options);
    modal.componentInstance.showFirstTime = firstTime;
  }

}
